export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const SSO_URL = process.env.REACT_APP_SSO_URL;
export const SSO_REDIRECT_URL = process.env.REACT_APP_SSO_REDIRECT_URL;
export const SSO_POST_LOGOUT_URL = process.env.REACT_APP_SSO_POST_LOGOUT_URL;
export const SSO_CANOPY_URL = process.env.REACT_APP_SSO_CANOPY_URL;
